import Navigation from "@/components/Navigation"
import HeroSection from "@/components/HeroSection"
import ProductsSection from "@/components/ProductsSection"
import ApplicationSection from "@/components/ApplicationSection"
import TeamSection from "@/components/TeamSection"
import OccasionsSection from "@/components/OccasionsSection"
import ValuesSection from "@/components/ValuesSection"
import TestimonialsSection from "@/components/TestimonialsSection"
import Footer from "@/components/Footer"
import MouseSparkles from "@/components/MouseSparkles"
import { BlackFridayPopup } from "@/components/BlackFridayPopup"
import LoyaltySection from "@/components/LoyaltySection"
import LoyaltyAnnouncement from "@/components/LoyaltyAnnouncement"

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <BlackFridayPopup />
      <LoyaltyAnnouncement />
      <MouseSparkles />
      <Navigation />
      <main>
        <HeroSection />
        <ProductsSection />
        <LoyaltySection />
        <ApplicationSection />
        <OccasionsSection />
        <ValuesSection />
        <TestimonialsSection />
        <TeamSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;